import { z } from 'zod';

export type AddressDto = z.infer<typeof AddressSchema>

export const AddressSchema = z.object({
  addressLine1: z.string().nullish(),
  addressLine2: z.string().nullish(),
  city: z.string().nullish(),
  postCode: z.string().nullish(),
  region: z.string().nullish(),
  country: z.string().nullish(),
  lat: z.number().nullish(),
  lon: z.number().nullish(),
});

export interface Coordinates {
  lat: number;
  lng: number;
}

export const CoordinatesSchema = z.object({
  lat: z.number(),
  lng: z.number(),
});
